import "./vuetify";
import "./axios";
import "./validator";
import "./vue-currency-filter";
import "../assets/styles/main.styl";
import currencyInput from "vue-currency-input";
import VueHtml2Canvas from 'vue-html2canvas';


// external libraries
import Vue from "vue";
import XlsxPopulate from "xlsx-populate";
import VAlert from "./vue-alert-component";

Vue.use(VAlert);
Vue.use(currencyInput);
Vue.use(VueHtml2Canvas)

window.XlsxPopulate = XlsxPopulate;
